import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLayoutChromeOptional } from '@/components/layout/layoutChrome';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  const location = useLocation();
  const chrome = useLayoutChromeOptional();
  const setSheetTitle = chrome?.setTitle;

  useEffect(() => {
    document.title = title;
  }, [location, title]);

  useLayoutEffect(() => {
    if (!setSheetTitle) return
    setSheetTitle(title)
    return () => setSheetTitle(null)
  }, [setSheetTitle, title]);

  return null;
};

export default PageTitle;
